export function getCategory(data) {
    let cats = data.category;
    return cats;
}
export function getEmotions(data) {
    let emotions = data.emotions;
    return emotions;
}


// WEBPACK FOOTER //
// ./src/compontent/handle.js